export default __webpack_public_path__ + "static/media/perso.bc07de0d.svg";